import Axios from "axios"
import {showMessage} from './promptUtil';
import signUtil from './SignUtil.js';

export default {
    /**
     * 封装ajax的get请求
     * @param url
     * @param params
     * @param successFun
     * @param failFun
     * @param errorFun
     */
    getJson:function(url,params,successFun,failFun,errorFun){

        var req = {
            url: url,
            method: 'get',
            params: signUtil.sign(params,url),
            headers:{'timestamp':new Date().getTime()}
        };
        Axios(req).catch(
            function(err){
                if(err.response && err.response.data  && err.response.data.result == 403){
                     window.onTokenExpireLoginAgain();
                }
                if(typeof errorFun == "function")
                    errorFun(err.response.data)
                else{
                    showMessage('失败',err.response&&err.response.data.message?err.response.data.message:"服务器通讯异常，请检查网络",'error');
                }
            }
        ).then(
            function(res){
                successFun(res?res.data:res);
            }
         )
    },
    /**
     *
     * @param url
     * @param params
     * @param successFun
     * @param failFun
     * @param errorFun
     */
    getNoCacheJson:function(url,params,successFun,failFun,errorFun){

        var req = {
            url: url,
            method: 'get',
            params: signUtil.sign(params,url),
            headers:{
                'Cache-Control':'no-cache',
                'timestamp':new Date().getTime()}
        };
        Axios(req).catch(
            function(err){
                if(err.response && err.response.data  && err.response.data.result == 403){
                    window.onTokenExpireLoginAgain();
                }
                if(typeof errorFun == "function")
                    errorFun(err.response.data)
                else{
                    showMessage('失败',err.response&&err.response.data.message?err.response.data.message:"服务器通讯异常，请检查网络",'error');
                }
            }
        ).then(
            function(res){
                successFun(res?res.data:res);
            }
        )
    },
    /**
     * 无tooken
     * @param url
     * @param params
     * @param successFun
     * @param failFun
     * @param errorFun
     */
    getNoStatusJson:function(url,params,successFun,failFun,errorFun){

        var req = {
            url: url,
            method: 'get',
            params: params
        };
        Axios(req).catch(
            function(err){

                if(typeof errorFun == "function")
                    errorFun(err.response.data)
                else{
                    showMessage('失败',err.response&&err.response.data.message?err.response.data.message:"服务器通讯异常，请检查网络",'error');
                }
            }
        ).then(
            function(res){
                successFun(res?res.data:res);
            }
        )
    },
    postJson:function(url,params,successFun,failFun,errorFun){
        var req = {
            url: url,
            method: 'POST',
            data: signUtil.sign(params,url),
            headers:{'timestamp':new Date().getTime()},
        };
        Axios(req).catch(
            function(err){
                if(err.result == 403){
                     window.onTokenExpireLoginAgain();
                }
                if(typeof errorFun == "function")
                    errorFun(err.response.data)
                else{
                    showMessage('失败',err.response&&err.response.data.message?err.response.data.message:"服务器通讯异常，请检查网络",'error');
                }
            }
        ).then(
            function(res){
                successFun(res.data);
            }
        );
    },
    postJsonNoToken:function(url,params,successFun,failFun,errorFun){
        var req = {
            url: url,
            method: 'POST',
            data: params,
            headers:{},
        };
        Axios(req).catch(
            function(err){
                if(err.result == 403){
                     window.onTokenExpireLoginAgain();
                }
                if(typeof errorFun == "function")
                    errorFun(err.response.data)
                else{
                    showMessage('失败',err.response&&err.response.data.message?err.response.data.message:"服务器通讯异常，请检查网络",'error');
                }
            }
        ).then(
            function(res){
                successFun(res.data);
            }
        );
    },
    postJsonAddMd5:function(url,params,successFun,failFun,errorFun){
        /*
        *
        **加密规则：只加密参数需要排序之后，以键值对的形式传输；
        **params.sig = "加密值"
        ****
        ***********/
        var params = signUtil.sign(params);
        var req = {
            url: url,
            method: 'POST',
            data: params,
            headers:{'timestamp':new Date().getTime()},
        };
        Axios(req).catch(
            function(err){
                if(err.result == 403){
                     window.onTokenExpireLoginAgain();
                }
                if(typeof errorFun == "function")
                    errorFun(err.response.data)
                else{
                    showMessage('失败',err.response&&err.response.data.message?err.response.data.message:"服务器通讯异常，请检查网络",'error');
                }
            }
        ).then(
            function(res){
                successFun(res.data);
            }
        );
    },
    getJsonAddMd5:function(url,params,successFun,failFun,errorFun){
       var params = signUtil.sign(params);
        var req = {
            url: url,
            method: 'get',
            params: params,
            headers:{'timestamp':new Date().getTime()}
        };
        Axios(req).catch(
            function(err){
                if(err.response && err.response.data  && err.response.data.result == 403){
                     window.onTokenExpireLoginAgain();
                }
                if(typeof errorFun == "function")
                    errorFun(err.response.data)
                else{
                    showMessage('失败',err.response&&err.response.data.message?err.response.data.message:"服务器通讯异常，请检查网络",'error');
                }
            }
        ).then(
            function(res){
                successFun(res?res.data:res);
            }
         )
    },
    postData: function(url,params,successFun,failFun){
      Axios({
          url: url,
          method: 'POST',
          data: params
      }).then(function(res){
        successFun(res);
      }).catch(function(res){
        failFun(res)
      })
    }
}



// WEBPACK FOOTER //
// ./src/pub/utils/ajaxUtil.js